// @flow

import { openDialog } from '../base/dialog';

import {
    ADD_CANDP_URL,
    RECEIVE_CANDP_URL,
    REMOVE_CANDP_URL,
    REMOVE_MOBILE_CANDP_URL } from './actionTypes';
import { enterDonorLinkPrompt } from './components';


/**
 * Adds url to Donation Box.
 *
 * @param {string} addCUrl - Url for inflicting the modal .
 * @returns {Function}
 */
export function addClickandPledgeurl(addCUrl: string) {

    return {
        type: ADD_CANDP_URL,
        addCUrl
    };
}

/**
 * Adds url to Donation Box.
 *
 * @param {string} getCUrl - Url for inflicting the modal .
 * @returns {Function}
 */
export function receiveClickandPledgeURl(getCUrl: string) {
    return {
        type: RECEIVE_CANDP_URL,
        getCUrl
    };
}

/**
 * Removes url from the  Donation Box.
 *
 * @param {string} url - Url for inflicting the modal .
 * @returns {Function}
 */
export function removeClickandPledgeUrl() {
    return {
        type: REMOVE_CANDP_URL
    };
}

/**
 * Displays the prompt for entering the Donorbox link.
 *
 * @param {Function} onPostSubmit - The function to be invoked when a valid link is entered.
 * @returns {Function}
 */
export function showEnterDonorLinkPrompt(onPostSubmit: ?Function) {
    return openDialog(enterDonorLinkPrompt, { onPostSubmit });
}


/**
 * Removes url from the  Donation Box.
 *
 * @param {string} url - Action for removing the donorbox button.
 * @returns {Function}
 */
export function removeMobileClickandPledgeURl() {
    return {
        type: REMOVE_MOBILE_CANDP_URL
    };
}
